<template>
  <div class="grid-container">
    <DxDataGrid
      :data-source="dados"
      :show-borders="true"
      :show-row-lines="true"
      :show-column-lines="true"
      :column-auto-width="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :row-alternation-enabled="true"
      :word-wrap-enabled="false"
      key-expr="id"
      @selection-changed="onSelectionChanged"
    >
      <!-- Toolbar -->
      <DxColumnChooser :enabled="true" mode="select" />
      <DxExport :enabled="true" :allow-export-selected-data="modoSelecao === 'multiple'" />
      <DxSearchPanel :visible="true" :width="240" placeholder="Buscar..." />
      <DxFilterRow :visible="true" />
      <DxHeaderFilter :visible="true" />

      <!-- Paginação -->
      <DxPaging :page-size="50" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[20, 50, 100, 200]"
        :show-info="true"
        :show-navigation-buttons="true"
      />

      <!-- Colunas na mesma ordem do formulário desktop; Lote e Validade só no grid de lotes -->
      <DxColumn data-field="Filial" caption="Filial" :width="120" alignment="left" />
      <DxColumn data-field="Almoxarifado" caption="Almoxarifado" :width="150" alignment="left" />
      <DxColumn data-field="CodigoReferencia" caption="Cód. Referência" :width="120" alignment="left" />
      <DxColumn data-field="Produto" caption="Item" :width="200" alignment="left" />
      <DxColumn data-field="Variacao" caption="Variação" :width="150" alignment="left" />
      <DxColumn
        data-field="Lote"
        caption="Lote"
        :width="120"
        alignment="left"
        :visible="mostrarColunaLote"
      />
      <DxColumn
        data-field="DataValidade"
        caption="Validade"
        data-type="date"
        :width="110"
        alignment="center"
        :visible="mostrarColunaLote"
      />
      <DxColumn
        data-field="Estoque"
        caption="Quantidade"
        data-type="number"
        format="#,##0.####"
        :width="120"
        alignment="right"
      />
      <DxColumn data-field="Unidade" caption="Unidade" :width="90" alignment="center" />
      <DxColumn data-field="Tipo" caption="Situação" :width="120" alignment="center" />
      <DxColumn data-field="Origem" caption="Origem" :width="180" alignment="left" />
      <DxColumn data-field="NumeroDocumento" caption="Documento" :width="160" alignment="left" />
      <DxColumn
        data-field="HandleOrigem"
        caption="Handle Origem"
        :width="100"
        alignment="center"
        :visible="false"
      />
      <DxColumn
        data-field="HandleLote"
        caption="Handle Lote"
        :width="100"
        alignment="center"
        :visible="false"
      />

      <!-- Summary (Totalizadores) -->
      <DxSummary>
        <DxTotalItem
          column="Estoque"
          summary-type="sum"
          display-format="Total: {0}"
          value-format="#,##0.####"
        />
        <DxTotalItem summary-type="count" display-format="Registros: {0}" />
      </DxSummary>

      <!-- Seleção -->
      <DxSelection
        :mode="modoSelecao"
        :show-check-boxes-mode="modoSelecao === 'multiple' ? 'always' : 'none'"
      />
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxExport,
  DxSearchPanel,
  DxFilterRow,
  DxHeaderFilter,
  DxPaging,
  DxPager,
  DxSummary,
  DxTotalItem,
  DxSelection,
  DxColumnChooser,
} from "devextreme-vue/data-grid";

export default {
  name: "RecuperaSaldosGrid",
  components: {
    DxDataGrid,
    DxColumn,
    DxExport,
    DxSearchPanel,
    DxFilterRow,
    DxHeaderFilter,
    DxPaging,
    DxPager,
    DxSummary,
    DxTotalItem,
    DxSelection,
    DxColumnChooser,
  },
  props: {
    dados: {
      type: Array,
      required: true,
    },
    mostrarColunaLote: {
      type: Boolean,
      default: false,
    },
    modoSelecao: {
      type: String,
      default: "multiple",
    },
  },
  methods: {
    onSelectionChanged(e) {
      this.$emit(
        "linha-selecionada",
        e.selectedRowsData.length > 0 ? e.selectedRowsData[0] : null
      );
    },
  },
};
</script>

<style scoped>
.grid-container {
  margin-top: 20px;
}
</style>
